import { useState } from 'react';
import { DataTable, Page, Card } from '@shopify/polaris';
import SettingsAddEditModal, { getSettingsEditLink } from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsQuotationsStatusesPage() {
  const [quotationstatuses, setQuotationstatuses] = useLookupStore((state) => [state.quotationstatuses, state.setQuotationstatuses]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({ offertestatustekst: { type: 'text', label: 'Status', max: '50', value: '' } });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const url = '/api/quotationstatuses';
  const title = 'Quotation statuses';

  const rows = quotationstatuses.map((item) => [item.offertestatustekst, getSettingsEditLink(setModalOpen, entry, setEntry, setIsAdd, setEntryId, item, item.offertestatusnr)]);

  return (
    <Page
      title={title}
      backAction={{ content: 'Settings', url: '/settings' }}
      primaryAction={{ content: 'Add quotation status', onAction: async () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId), disabled: true }}
    >
      <SettingsAddEditModal
        modalTitle={title}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setQuotationstatuses}
      />
      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
      <Card>
        <DataTable stickyHeader increasedTableDensity verticalAlign="middle" columnContentTypes={['text', 'numeric']} headings={[<b>Status</b>, <b>Edit</b>]} rows={rows} />
      </Card>
    </Page>
  );
}
